import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-more.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const MoreIcon = createSvgIcon(<Icon />, 'MoreIcon');
